export default "__VITE_ASSET__3DI7cykB__"